import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule, MatCardModule, MatInputModule, MatCheckboxModule } from '@angular/material';

import { PublicComponent } from './public.component';
import { LoginComponent } from './login/login.component';
import { PublicRoutingModule } from './public-routing-module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthService } from '../_services/auth/auth.service';

@NgModule({
  declarations: [
    PublicComponent,
    LoginComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCardModule,
    MatInputModule,
    MatCheckboxModule,
    PublicRoutingModule
  ],
  providers:[
    AuthService
  ]
})
export class PublicModule { }
